var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/ZerosingReport.scss";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import di from "./di/serviceLocator";
import Select from "react-select";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import AllReports from "./AllReports";
import ReportTable from "./ReportTable";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import EdModal from "@frameworks/shared-library/components/edModal";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import { DownloadTimeCategory } from "../Downloads/downloadConstants";
import TentativeOrFinalPopUp from "./TentativeOrFinalPopUp";
import Loader from "@frameworks/shared-library/components/Loader";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
var ZerosingReport = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var categoryId = useParams().categoryId;
    categoryId = atob(categoryId);
    var categoryName = useParams().categoryName;
    categoryName = atob(categoryName);
    var _k = __read(useState(false), 2), viewAllReports = _k[0], setViewAllReports = _k[1];
    var _l = __read(useState([]), 2), equityCommoditydropdownList = _l[0], setEquityCommoditydropdownList = _l[1];
    var _m = __read(useState([]), 2), quarterOrHalfYearlydropdownList = _m[0], setquarterOrHalfYearlydropdownList = _m[1];
    var _o = __read(useState(false), 2), noDataFound = _o[0], setNoDataFound = _o[1];
    var _p = __read(useState([]), 2), fieldInfo = _p[0], setFieldInfo = _p[1];
    var _q = __read(useState(false), 2), showPopUp = _q[0], setShowPopUp = _q[1];
    var _r = __read(useState(null), 2), formData = _r[0], setFormData = _r[1];
    var _s = __read(useState(undefined), 2), allReportList = _s[0], setAllReportList = _s[1];
    var _t = __read(useState(false), 2), isShowTable = _t[0], setIsShowTable = _t[1];
    var _u = __read(useState(undefined), 2), tableData = _u[0], setTableData = _u[1];
    var _v = __read(useState(false), 2), loader = _v[0], setLoader = _v[1];
    var _w = __read(useState(undefined), 2), exportStatus = _w[0], setExportStatus = _w[1];
    var _x = __read(useState(false), 2), isView = _x[0], setIsView = _x[1];
    var _y = __read(useState({}), 2), errorObj = _y[0], setErrorObj = _y[1];
    var _z = __read(useState(false), 2), isQuarterHalfEnable = _z[0], setIsQuarterHalfEnable = _z[1];
    var _0 = __read(useState(""), 2), monthlyQuarterlyLabel = _0[0], setMonthlyQuarterlyLabel = _0[1];
    var navigate = useNavigate();
    var handleChange = function (name, value) {
        setFormData(function (form) {
            var _a;
            return __assign(__assign({}, form), (_a = {}, _a[name] = value, _a));
        });
    };
    var handleError = function (name, message) {
        setErrorObj(function (prev) {
            var _a;
            var updatedData = __assign(__assign({}, prev), (_a = {}, _a[name] = message, _a));
            return updatedData;
        });
    };
    var getReportFieldValues = function () {
        di.salesReporting
            .getReportParamsData({ reportId: categoryId })
            .then(function (response) {
            if ((response === null || response === void 0 ? void 0 : response.adminKpiFilterData.length) > 0) {
                var fieldData_1 = response === null || response === void 0 ? void 0 : response.adminKpiFilterData.map(function (fieldValues) {
                    var _a, _b;
                    if (fieldValues.filter_type === "ddl" &&
                        !(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.parent_id)) {
                        getDropdownList(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.id);
                    }
                    var options = [];
                    if (((_a = fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.values) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        options = (_b = fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.values) === null || _b === void 0 ? void 0 : _b.map(function (option) {
                            return {
                                display: option === null || option === void 0 ? void 0 : option.name,
                                value: option === null || option === void 0 ? void 0 : option.value,
                            };
                        });
                    }
                    return {
                        id: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.id,
                        fieldName: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.filter_name,
                        fieldType: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.filter_type,
                        isMandatory: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.isMandatory,
                        fieldParams: fieldValues.kpi_params,
                        displayorder: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.displayorder,
                        radioOptions: options,
                    };
                });
                setFieldInfo(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), __read(fieldData_1), false); });
            }
            setIsView(!!(response === null || response === void 0 ? void 0 : response.isview));
        })
            .catch(function () { });
    };
    var getDropdownList = function (ddlid, userinput) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                ddlid: ddlid,
                userinput: userinput,
            };
            //   setLoader(true);
            di.salesReporting
                .getRmPartnerReportDropdownList(payload)
                .then(function (List) {
                var _a;
                if (((_a = List === null || List === void 0 ? void 0 : List.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    if (payload.ddlid == 29) {
                        setquarterOrHalfYearlydropdownList(function (prev) { return __spreadArray([
                            { label: "Select", value: "" }
                        ], __read(List.data), false); });
                    }
                    else {
                        setEquityCommoditydropdownList(function (prev) { return __spreadArray([
                            { label: "Select", value: "" }
                        ], __read(List.data), false); });
                    }
                }
                // setLoader(false);
            })
                .catch(function (error) {
                // setLoader(false);
            });
            return [2 /*return*/];
        });
    }); };
    var getTableDetails = function () {
        var column = Object === null || Object === void 0 ? void 0 : Object.keys(tableData === null || tableData === void 0 ? void 0 : tableData.tabledata[0]);
        var columnHeader = [];
        column.map(function (val) {
            // const value = tableData[0][val];
            columnHeader.push({
                name: val,
                key: val,
                // columnClass: value && !isNaN(Number(value)) ? "text-end" : "",
            });
        });
        return columnHeader;
    };
    var getReportTableData = function (isDownload, page) {
        if (isDownload === void 0) { isDownload = false; }
        setIsShowTable(false);
        setLoader(true);
        var payload = {
            isDownload: isDownload,
            page: page ? page.toString() : "1",
            pageSize: "50",
            mainReqBody: {
                kpi_id: 2,
                filter_params: { fromdate: "2024-07-01", todate: "2024-07-02" },
            },
        };
        di.salesReporting
            .getReportData(payload)
            .then(function (resp) {
            var _a, _b;
            if ((resp === null || resp === void 0 ? void 0 : resp.tabledata) && ((_a = resp === null || resp === void 0 ? void 0 : resp.tabledata) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setTableData(resp);
                setIsShowTable(true);
                setNoDataFound(false);
            }
            else if ((_b = resp === null || resp === void 0 ? void 0 : resp.isDownloadData) === null || _b === void 0 ? void 0 : _b.isDownload) {
                setExportStatus(resp === null || resp === void 0 ? void 0 : resp.isDownloadData);
            }
            else {
                setIsShowTable(false);
                setTableData(undefined);
                setNoDataFound(true);
            }
            setLoader(false);
        })
            .catch(function (error) {
            setIsShowTable(false);
            setTableData(undefined);
            setNoDataFound(true);
            setLoader(false);
        });
    };
    var scroll = function () {
        document.getElementById("report-table-id").scrollIntoView({
            block: "start",
            behavior: "smooth",
            inline: "start",
        });
        return true;
    };
    var getAllReports = function () {
        setLoader(true);
        di.salesReporting
            .getAllReport()
            .then(function (resp) {
            setAllReportList(resp);
            setLoader(false);
        })
            .catch(function (error) {
            setLoader(false);
        });
    };
    var handleSubmit = function () {
        var isError = false;
        fieldInfo === null || fieldInfo === void 0 ? void 0 : fieldInfo.forEach(function (fieldDetail) {
            if (isError)
                return;
            if ((fieldDetail === null || fieldDetail === void 0 ? void 0 : fieldDetail.fieldParams) === "Quarter" &&
                fieldDetail.isMandatory &&
                !isQuarterHalfEnable) {
                return;
            }
            if (fieldDetail.isMandatory && fieldDetail.fieldParams) {
                if (formData == null || formData == undefined) {
                    isError = true;
                    handleError(fieldDetail.fieldParams, "This field is Required");
                }
                else if (formData &&
                    typeof formData === "object" &&
                    (!formData.hasOwnProperty(fieldDetail.fieldParams) ||
                        !formData[fieldDetail.fieldParams])) {
                    isError = true;
                    handleError(fieldDetail.fieldParams, "This field is Required");
                }
            }
        });
        if (isError)
            return;
        getReportTableData();
    };
    var getMonthlyQuarterlyLabel = function (eqCo, tentativeFinal) {
        var _a, _b;
        di.salesReporting
            .getZeroisingLabel({
            Id: (_b = (_a = fieldInfo[3]) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString(),
            EqCo: eqCo,
            tentativeFinal: tentativeFinal,
        })
            .then(function (response) {
            if (response.data)
                setMonthlyQuarterlyLabel(response.data);
            else
                setMonthlyQuarterlyLabel("");
        })
            .catch(function (error) {
            setMonthlyQuarterlyLabel("");
        });
    };
    useEffect(function () {
        if (categoryId) {
            getReportFieldValues();
        }
        getAllReports();
    }, [categoryId]);
    return (React.createElement(GridContainer, { parentClass: "zerosing-report-block" },
        loader ? React.createElement(Loader, { className: "report-view-loader" }) : React.createElement(React.Fragment, null),
        React.createElement("div", { className: "header-container d-flex align-items-center justify-content-between" },
            React.createElement("span", { className: "DMSan_28_700 txt-midnight-blue" }, categoryName),
            React.createElement("span", { onClick: function () {
                    setViewAllReports(true);
                }, className: "cursor-pointer" },
                React.createElement("u", { className: "DMSan_16_700 txt-midnight-blue" }, "All Reports"))),
        React.createElement("form", { className: "zerosing-form-body bg_white", onSubmit: function (e) {
                e.preventDefault();
                handleSubmit();
            } },
            React.createElement("div", { className: " d-flex align-items-center single-field" },
                React.createElement("span", { className: "DMSanN_16_400 field-label" }, "Equity/Commodity :"),
                React.createElement("div", null,
                    React.createElement(Select, { name: "externalParticipants", options: equityCommoditydropdownList, className: "basic-multi-select DMSanN_14_400 txt_blackOne1 equity-drop", classNamePrefix: "select", onChange: function (e) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            if (!e.value) {
                                setIsQuarterHalfEnable(false);
                                handleChange((_a = fieldInfo[2]) === null || _a === void 0 ? void 0 : _a.fieldParams, "");
                            }
                            else if (e.value &&
                                formData &&
                                !!formData[(_b = fieldInfo[2]) === null || _b === void 0 ? void 0 : _b.fieldParams]) {
                                getMonthlyQuarterlyLabel((_c = e.value) === null || _c === void 0 ? void 0 : _c.toString(), (_e = formData[(_d = fieldInfo[2]) === null || _d === void 0 ? void 0 : _d.fieldParams]) === null || _e === void 0 ? void 0 : _e.toString());
                                if (formData[(_f = fieldInfo[2]) === null || _f === void 0 ? void 0 : _f.fieldParams] === "Final")
                                    getDropdownList((_g = fieldInfo[4]) === null || _g === void 0 ? void 0 : _g.id, (_h = e.value) === null || _h === void 0 ? void 0 : _h.toString());
                            }
                            handleError((_j = fieldInfo[0]) === null || _j === void 0 ? void 0 : _j.fieldParams, "");
                            handleChange((_k = fieldInfo[0]) === null || _k === void 0 ? void 0 : _k.fieldParams, e === null || e === void 0 ? void 0 : e.value);
                        }, closeMenuOnSelect: true, required: true }),
                    ((_a = fieldInfo[0]) === null || _a === void 0 ? void 0 : _a.fieldParams) &&
                        errorObj[(_b = fieldInfo[0]) === null || _b === void 0 ? void 0 : _b.fieldParams] && (React.createElement("p", { className: "help_text red" }, "This field is required"))),
                React.createElement("span", { className: "ms-3 tentative-button" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Tentative/Final Tagging", type: "button", onClick: function () {
                            setShowPopUp(!showPopUp);
                        } }))),
            React.createElement("div", { className: " d-flex align-items-center single-field" },
                React.createElement("span", { className: "DMSanN_16_400 field-label" }, "Zeroising Type : "),
                (fieldInfo === null || fieldInfo === void 0 ? void 0 : fieldInfo.length) > 0 &&
                    ((_d = (_c = fieldInfo[2]) === null || _c === void 0 ? void 0 : _c.radioOptions) === null || _d === void 0 ? void 0 : _d.map(function (item, idx) {
                        var _a;
                        return (React.createElement(RadioButton, { key: idx, list: item, name: "ZeroisingType", required: (_a = fieldInfo[2]) === null || _a === void 0 ? void 0 : _a.isMandatory, onChange: function (e) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                if (formData === undefined || formData === null) {
                                    setErrorObj(function (prev) {
                                        var _a;
                                        var _b;
                                        var updatedData = __assign(__assign({}, prev), (_a = {}, _a[(_b = fieldInfo[0]) === null || _b === void 0 ? void 0 : _b.fieldParams] = "This field is required", _a));
                                        return updatedData;
                                    });
                                }
                                else if (((_a = fieldInfo[0]) === null || _a === void 0 ? void 0 : _a.fieldParams) &&
                                    (!formData.hasOwnProperty((_b = fieldInfo[0]) === null || _b === void 0 ? void 0 : _b.fieldParams) ||
                                        !formData[(_c = fieldInfo[0]) === null || _c === void 0 ? void 0 : _c.fieldParams])) {
                                    handleError((_d = fieldInfo[0]) === null || _d === void 0 ? void 0 : _d.fieldParams, "This field is required");
                                }
                                else {
                                    handleChange((_e = fieldInfo[2]) === null || _e === void 0 ? void 0 : _e.fieldParams, item === null || item === void 0 ? void 0 : item.value);
                                    getMonthlyQuarterlyLabel(formData[(_f = fieldInfo[0]) === null || _f === void 0 ? void 0 : _f.fieldParams], (_g = item.value) === null || _g === void 0 ? void 0 : _g.toString());
                                    if (item.value === "Final") {
                                        setIsQuarterHalfEnable(true);
                                        getDropdownList((_h = fieldInfo[4]) === null || _h === void 0 ? void 0 : _h.id, formData[(_j = fieldInfo[0]) === null || _j === void 0 ? void 0 : _j.fieldParams]);
                                    }
                                    else {
                                        setIsQuarterHalfEnable(false);
                                    }
                                }
                            }, selected: formData && formData[fieldInfo[2].fieldParams]
                                ? formData[fieldInfo[2].fieldParams]
                                : "", className: "common-radio-button" }));
                    }))),
            React.createElement("div", { className: " d-flex align-items-center single-field" },
                React.createElement("span", { className: "DMSanN_16_400 field-label" },
                    "Monthly/Quarterly :",
                    " "),
                formData &&
                    formData[fieldInfo[2].fieldParams] &&
                    ((_e = fieldInfo[0]) === null || _e === void 0 ? void 0 : _e.fieldParams) && (React.createElement("span", { className: "DMSanM_14_500" },
                    " ",
                    monthlyQuarterlyLabel))),
            formData &&
                formData[fieldInfo[2].fieldParams] === "Final" &&
                formData[(_f = fieldInfo[0]) === null || _f === void 0 ? void 0 : _f.fieldParams] && (React.createElement("div", { className: "d-flex align-items-center single-field" },
                React.createElement("span", { className: "DMSanN_16_400 field-label" }, formData && formData[(_g = fieldInfo[0]) === null || _g === void 0 ? void 0 : _g.fieldParams] === "CO"
                    ? "Half Yearly : "
                    : "Quarter : "),
                React.createElement("div", null,
                    React.createElement(Select, { defaultValue: equityCommoditydropdownList[0], name: "externalParticipants", options: quarterOrHalfYearlydropdownList, className: "basic-multi-select DMSanN_14_400 txt_blackOne1", classNamePrefix: "select", onChange: function (e) {
                            var _a, _b;
                            handleError((_a = fieldInfo[4]) === null || _a === void 0 ? void 0 : _a.fieldParams, "");
                            handleChange((_b = fieldInfo[4]) === null || _b === void 0 ? void 0 : _b.fieldParams, e === null || e === void 0 ? void 0 : e.value);
                        }, closeMenuOnSelect: true }),
                    ((_h = fieldInfo[4]) === null || _h === void 0 ? void 0 : _h.fieldParams) &&
                        errorObj[(_j = fieldInfo[4]) === null || _j === void 0 ? void 0 : _j.fieldParams] && (React.createElement("p", { className: "help_text red" }, "This field is required"))))),
            React.createElement("div", { className: " d-flex align-items-center button-block gap-2 justify-content-center mt-5" },
                isView && (React.createElement(EdButton, { onClick: function () {
                        //   getReportTableData(true);
                    }, 
                    // disabled={isDownload}
                    type: "submit", btnTyp: "midnight-blue", value: "Submit", className: "form-btn" })),
                React.createElement(EdButton, { onClick: function () {
                        getReportTableData(true);
                    }, 
                    // disabled={isDownload}
                    type: "button", btnTyp: "midnight-blue", value: "Export", className: "form-btn" }))),
        viewAllReports && (React.createElement(GenericSidebar, { parentClassname: "", header: React.createElement("div", { className: "d-flex justify-content-between align-items-center " },
                React.createElement("div", { className: "  DMSans_16_500 txt_blackOne1" }, "All Reports")), body: React.createElement("div", { className: "all-reports bg-white position-relative" },
                React.createElement(AllReports, { reports: allReportList })), footer: "", openKey: viewAllReports, setOpenKey: setViewAllReports, arrowClose: true, delay: 10 })),
        React.createElement("div", { id: "report-table-id", className: "mt-4" }, isShowTable && scroll() && (React.createElement(ReportTable, { columnsList: getTableDetails(), tbodyData: tableData === null || tableData === void 0 ? void 0 : tableData.tabledata, showEntries: true, currentPage: tableData === null || tableData === void 0 ? void 0 : tableData.currentpage, totalPages: tableData === null || tableData === void 0 ? void 0 : tableData.totalpages, getCurrentPage: function (page) {
                getReportTableData(false, page);
            } }))),
        noDataFound && isView && scroll() && (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })),
        React.createElement("div", { className: "export-popup" }, (exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.isDownload) && (React.createElement(EdModal, { show: exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.isDownload, setShow: function (val) {
                setExportStatus(function (prev) { return (__assign(__assign({}, prev), { isDownload: val })); });
            }, size: "modal-dialog-centered", showFooter: false, modalTitle: " ", title: "Downloading", children: React.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center export-child" },
                React.createElement("div", { className: "mb-2" },
                    React.createElement(Edelicon, { className: "edel-icon-successful-icon", paths: 5 })),
                React.createElement("div", { className: "mb-2 DMSanBold_18_700 txt-midnight-blue" }, exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.title),
                React.createElement("div", { className: "DMSansNormal_12_400 txt_blue-tint mx-5 text-center text-block" }, exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.message),
                React.createElement("div", { className: "hand_cursor d-flex align-items-center my-3" },
                    React.createElement(Edelicon, { className: "edel-icon-download-page me-2", paths: 3 }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "My Downloads", onClick: function () {
                            setExportStatus(function (prev) { return (__assign(__assign({}, prev), { isDownload: false })); });
                            navigate("/dashboard/downloads", {
                                state: { showToday: DownloadTimeCategory.TODAY },
                            });
                        } }))) }))),
        React.createElement("div", { className: "tentative-final" }, showPopUp && (React.createElement(EdModal, { show: showPopUp, setShow: function (val) {
                setShowPopUp(val);
            }, showFooter: false, modalTitle: " ", size: "modal-dialog-centered", title: "Tentative Or Final", children: React.createElement(TentativeOrFinalPopUp, null) })))));
};
export default ZerosingReport;
